import { AuthService } from './../user/auth.service';
import { Observable } from 'rxjs/Observable';
import { RegistryService } from './../registry/registry.service';
import { Subject } from 'rxjs/Subject';
import { RegistryFirebaseService } from './../registry/registry-firebase.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ChangeDetectorRef, HostListener } from '@angular/core';
import { ToastType } from './toast.enum';
import { Component, OnInit, Input } from '@angular/core';
import { Gift } from '../gift/gift';
import { Registry } from '../registry/registry';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})


export class ToastComponent implements OnInit {

  @Input() isLoggedIn: boolean;
  @Input() registry: Registry;
  isPublished = false;
  currentPage = 'registry';
  stripeVerified = false;
  justCreatedGift = localStorage.getItem('toast_' + ToastType.createdGift) === 'true';

  scrollPoint: number;
  isCtaDismissed = localStorage.getItem('toast_' + ToastType.demoCtaDismissed) === 'true';
  isAddedToCart = false;
  isOnRegistryPage = false;
  secondsInMilliseconds = 1000;
  gifts: Gift[];
  latestGift: Gift;
  isOnGiftDescriptionPage = false;
  giftCreated = false
  toastText:string;

  wishSent = false;
  showToast: boolean;
  @HostListener('window:scroll', ['$event'])
  onWindowScroll($event) {
if ($event && $event.path && $event.path.length > 0) {
    this.scrollPoint = $event.path[1].scrollY;
}
  }

  constructor(
    private _activeRoute: ActivatedRoute,
    private _router: Router,
    private cdr: ChangeDetectorRef,
    private _registryFirebaseService: RegistryFirebaseService,
    private _registryService: RegistryService,
    private _authService: AuthService

  ) {


    if (this._registryService.getWishSent()) {
      this.wishSent = true;
      window.scroll(0, 0);
      setTimeout(() => {
        this.wishSent = false;
        this._registryService.setWishSent(false);
      }, 6 * this.secondsInMilliseconds);
    }


    this._registryService.toastTypeEmitted$.subscribe(toastType => {
      
      if (toastType === ToastType.createdGift) {
        this.giftCreated = true;
        setTimeout(() => {
          this.giftCreated = false;
        }, 6 * this.secondsInMilliseconds);
      }
    });
    

    this._registryService.toastGenericEmitted$.pipe(
      switchMap(toastText => {
        
        this.toastText = toastText;
        this.showToast = true;
        if(this.cdr && !this.cdr['destroyed']){        
        this.cdr.detectChanges(); // Ensure the view updates
        }
        // Return an observable that completes after 2 seconds
        return new Observable(observer => {
          
          const timeout = setTimeout(() => {
            this.toastText = null;
            observer.next();
            observer.complete();
          }, 2000);

          // Cleanup function to clear the timeout if the observable is unsubscribed
          return () => clearTimeout(timeout);
        });
      })
    ).subscribe(() => {
      this.showToast = false; // Hide the toast after 2 seconds
      if(this.cdr && !this.cdr['destroyed']){        
        this.cdr.detectChanges(); // Ensure the view updates
        }
    });
    this._authService.user.subscribe(user => {
      if (user) {
        this.isLoggedIn = true;
      }
    });



    const mainComponent: any = this._activeRoute.component;
    this.isOnRegistryPage = mainComponent.name === 'RegistryComponent' || mainComponent.name === 'WebsiteBuilderComponent';

    if (this.justCreatedGift) {
      setTimeout(() => {
        this.justCreatedGift = false;
        localStorage.setItem('toast_' + ToastType.createdGift, '');
      }, 7.5 * this.secondsInMilliseconds);
    }


  }
  close() {
    this.justCreatedGift = false;
  }

  clearCreateToast() {
    localStorage.setItem('toast_' + ToastType.createdGift, '');
  }


  dissmissCTA() {
    localStorage.setItem('toast_' + ToastType.demoCtaDismissed, 'true');
    this.isCtaDismissed = true;
  }
  isDemoRegistry(): boolean {
    return true;
  }

  dismissShare() {
    this.stripeVerified = this.checkIfAccountIsVerified();
  }

  checkIfAccountIsVerified(): boolean {
    return false;
  }

  dismissShareToast() {
    // this.showDismissed = true;
    localStorage.setItem('toast_' + ToastType.share, 'true');
  }

  ngOnInit() {
    if (this.registry && !this.isOnRegistryPage && this.registry.isDemo && !this.isCtaDismissed)
    {}

    if (this.isAddedToCart) {
      // show added to cart toast.
    }


    if (this.isLoggedIn) {
      /// registry///
      if (this.isPublished && this.currentPage === 'registry') {
        // show the share toast which dismissed
      } else if (this.isPublished && this.currentPage === 'registry' && !this.stripeVerified) {
        // show verify your stripe account
      }
      ////////////////
      //// gift description and is logged in
      if (this.currentPage === 'gift description' && this.justCreatedGift) {
        // show (back arrow goes to reg)
        // Gift created toast
        // create another gift link.
      }

      //
      /////
    } else {

      if ((this.currentPage === 'registry' || this.currentPage === 'gift description')
        && this.isDemoRegistry() && this.scrollPoint >= 200 && !this.isCtaDismissed) {
        // show CTA guestmode
      }


    }

  }


}



// WEBPACK FOOTER //
// ./src/app/toast/toast.component.ts